import React, { useEffect, useState } from "react";

const initialState = {
  first_name: "",
  last_name: "",
  email: "",
  password: "",
  organization: "",
};

function AddAdminModal({ isOpen, onClose, onSuccess, admin }) {
  const [formData, setFormData] = useState(initialState);

  const [loading, setLoading] = useState(false);

  const [organizations, setOrganizations] = useState([]);
  const [loadingOrganizations, setLoadingOrganizations] = useState(false);

  useEffect(() => {
    if (admin) {
      setFormData({
        first_name: admin.first_name || "",
        last_name: admin.last_name || "",
        email: admin.email || "",
        password: "",
        organization: admin.organization || "",
      });
    } else {
      setFormData(initialState);
    }
  }, [admin, isOpen]);

  useEffect(() => {
    fetchOrganizations();
  }, []);

  const fetchOrganizations = async () => {
    try {
      setLoadingOrganizations(true);

      const token = localStorage.getItem("adminToken");

      const response = await fetch(
        "https://testone.conversationaily.ai/api/organizations",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();

      setOrganizations(data?.organizations || data || []);
    } catch (error) {
      console.error("Failed to fetch organizations:", error);
    } finally {
      setLoadingOrganizations(false);
    }
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const token = localStorage.getItem("adminToken");

      const isEdit = !!admin;

      const url = isEdit
        ? `https://consult.conversationaily.ai/api/admin/${admin.id}/update`
        : "https://testone.conversationaily.ai/api/admin/create";

      const method = isEdit ? "PUT" : "POST";

      const payload = {
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        organization: formData.organization,
      };

      // Password only while creating or if changed
      if (!isEdit || formData.password) {
        payload.password = formData.password;
      }

      const response = await fetch(url, {
        method,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || "Request failed");
      }

      // alert(
      //   isEdit
      //     ? "Admin updated successfully."
      //     : "Admin created successfully."
      // );

      setFormData(initialState);

      onSuccess?.();
      onClose();
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-xl">
        <div className="px-6 py-4 border-b">
          <h2 className="text-lg font-semibold">
            {admin ? "Update Admin" : "Add Admin"}
          </h2>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="p-6 space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm mb-1">First Name</label>
                <input
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  required
                  className="w-full border border-gray-300 rounded-lg px-3 py-2"
                />
              </div>

              <div>
                <label className="block text-sm mb-1">Last Name</label>
                <input
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  required
                  className="w-full border border-gray-300 rounded-lg px-3 py-2"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm mb-1">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded-lg px-3 py-2"
              />
            </div>

            <div>
              <label className="block text-sm mb-1"><label className="block text-sm mb-1">
                Password {admin && "(Leave blank to keep current password)"}
              </label></label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required={!admin}
                className="w-full border border-gray-300 rounded-lg px-3 py-2"
              />
            </div>


            <div>
              <label className="block text-sm mb-1">Organization</label>

              <select
                name="organization"
                value={formData.organization}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded-lg px-3 py-2"
              >
                <option value="">
                  {loadingOrganizations
                    ? "Loading organizations..."
                    : "Select Organization"}
                </option>

                {organizations.map((org) => (
                  <option
                    key={org.id}
                    value={org.code}
                  >
                    {org.name || org.organization_name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="flex justify-end gap-3 px-6 py-4 border-t">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border rounded-lg"
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 disabled:opacity-50"
            >
              {loading
                ? admin
                  ? "Updating..."
                  : "Creating..."
                : admin
                  ? "Update Admin"
                  : "Create Admin"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddAdminModal;